/**
 * Up-front integration-limit copy (MOT-808). The numbers come from
 * GET /integrations/capacity, which uses the same count the create path enforces.
 */
export interface IntegrationCapacity {
  used: number;
  limit: number;
  overageAllowed: boolean;
  canAdd: boolean;
  planName: string | null;
}

export function isAtIntegrationLimit(capacity: IntegrationCapacity | null | undefined): boolean {
  return !!capacity && capacity.canAdd === false;
}

/** Translation key and params for the limit sentence, or null when another integration is allowed. */
export function integrationLimitMessageKey(
  capacity: IntegrationCapacity | null | undefined,
): { key: string; params?: Record<string, string | number> } | null {
  if (!isAtIntegrationLimit(capacity) || !capacity) return null;
  if (capacity.limit <= 0) return { key: 'integrations.integrationLimit.none' };
  const one = capacity.limit === 1;
  if (capacity.planName) {
    return {
      key: one ? 'integrations.integrationLimit.bodyOne' : 'integrations.integrationLimit.bodyMany',
      params: { plan: capacity.planName, limit: capacity.limit, used: capacity.used },
    };
  }
  return {
    key: one ? 'integrations.integrationLimit.bodyOneNoPlan' : 'integrations.integrationLimit.bodyManyNoPlan',
    params: { limit: capacity.limit, used: capacity.used },
  };
}
